/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceFileSource = {
    ManualUpload: 'MANUAL_UPLOAD',
    PublicRegistry: 'PUBLIC_REGISTRY',
    Autogenerated: 'AUTOGENERATED'
} as const;
export type ComplianceFileSource = typeof ComplianceFileSource[keyof typeof ComplianceFileSource];


export function instanceOfComplianceFileSource(value: any): boolean {
    for (const key in ComplianceFileSource) {
        if (Object.prototype.hasOwnProperty.call(ComplianceFileSource, key)) {
            // @ts-ignore
            if (ComplianceFileSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceFileSourceFromJSON(json: any): ComplianceFileSource {
    return ComplianceFileSourceFromJSONTyped(json, false);
}

export function ComplianceFileSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceFileSource {
    return json as ComplianceFileSource;
}

export function ComplianceFileSourceToJSON(value?: ComplianceFileSource | null): any {
    return value as any;
}

